<template>
  <Card
    variant="widget"
    tag="form"
    :title="$t('publishingOfTheProject')"
    :subtitle="$t('publishingOfThePageSubtitle')"
    class="project-mutate-publishing"
    :class="[{ 'project-mutate-publishing--has-reference-selector': showReferenceSelector }]"
    @submit.prevent="$emit('submit')"
  >
    <template #default>
      <div class="project-mutate-publishing__input">
        <FieldRenderer v-for="item in fields.default" :validator="validator" :item="item" :value="value" />
      </div>

      <CustomFields
        v-model="value.customFields"
        :schema="customFieldSchemas"
        :data="data"
        :placement="['publishing', 'project:publishing']"
        data-field="custom-fields"
        :validator="validator"
        validator-prefix="customFields"
        :disabledFields="$path('metadata.disabledFields.project', item)"
      >
        <template v-for="item in fields.slots" v-slot:[item.slotKey]>
          <FieldRenderer :validator="validator" :item="item" :value="value" />
        </template>
      </CustomFields>
    </template>
  </Card>
</template>

<script>
import { mapState } from 'vuex'
import Card from '@/components/Card-v2'
import { InputComponent } from 'vue-elder-input'
import { i18n } from '@/i18n'
import CustomFields from '@kvass/custom-fields'
import CustomFieldSchemas from '@/components/Project/CustomFieldSchemas'
import FieldRenderer from '@/components/Project/StepsFields/FieldRenderer.vue'

const meta = {
  order: 1006,
  id: 'publishing',
  label: i18n.tc('publishing'),
  icon: ['fal', 'globe'],
  fields: ['publishing.domain'],
}

export { meta }
export default {
  props: {
    data: Object,
    value: Object,
    labels: Object,
    isActive: Boolean,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('Project', {
      item(state) {
        return state.item && Object.keys(state.item).length ? state.item : this.data
      },
    }),
    showReferenceSelector() {
      return (
        this.$path(['metadata', 'publishOnPage', 'hasPage'], this.item) &&
        !['tase', 'fjelge', 'livd'].includes(this.item.theme)
      )
    },
  },
  components: {
    Card,
    InputComponent,
    CustomFields,
    CustomFieldSchemas,
    FieldRenderer,
  },
}
</script>

<style lang="scss">
.project-mutate-publishing {
  max-width: 800px;

  [data-field='custom-fields'] {
    margin-top: 1rem;
  }

  &--has-reference-selector {
    max-width: 1240px;
    [data-field='custom-fields'] {
      margin-top: 0rem;
    }
  }

  .card-v2__subtitle {
    margin-top: 1rem;
    max-width: 800px;
  }
}
</style>
